export enum ProductType {
    SEDESTRAL = 1,
    PUBLISHER = 3,
    PANEL = 8,
    WEBSITE = 25,
    BLOG = 27,
    COMMUNITY = 29,
    ADMIN = 30,
    GSC_INDEXING = 31,
    GSC_WEBMASTERS = 32,
    GOOGLE_BUSINESS_MANAGE = 33
}